import { render, staticRenderFns } from "./ItemsComponent.vue?vue&type=template&id=e94ca438&scoped=true&"
import script from "./ItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemsComponent.vue?vue&type=style&index=0&id=e94ca438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94ca438",
  null
  
)

export default component.exports